import React from "react";
import Trygve from "../assets/images/trygve_storrønningen.png";
import Oksana from "../assets/images/oksana_nikitenko.jpg";
import { Box, Typography, Grid } from "@mui/material";
import TranslatedText from "./TranslatedText";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "../Styles/OmOss.css";
import "../App.css";

const OmOss = () => {
  return (
    <Box component="main" sx={{ p: 3 }}>
      <Typography
        variant="h2"
        sx={{
          fontSize: 40,
          textAlign: "left",
          paddingTop: 9,
          "@media screen and (max-width: 600px)": { fontSize: "28px" },
        }}
        gutterBottom
      >
        <TranslatedText defaultText="Про нас" />
      </Typography>

      <div class="about-item-text">
        <Typography
          variant="h3"
          sx={{
            fontSize: 20,
            fontWeight: 100,
            marginTop: 2,
            "@media screen and (max-width: 600px)": { fontSize: "18px" },
          }}
          gutterBottom
        >
          <TranslatedText defaultText=" Сьогоднішні події в Україні стосуються не тільки українського народу, а й міжнародної спільноти. Ми прагнемо активно підтримувати Україну у боротьбі за свої національні інтереси та збереження демократії." />
        </Typography>
      </div>

      <hr className="about-rule" />
      <br></br>

      <Grid
        className="about-container"
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item className="about-item" xs={6}>
          <div class="about-img1">
            <img src={Trygve} alt="" style={{ width: "100%", height: "20%" }} />
          </div>
        </Grid>
        <Grid item className="item-text" xs={6}>
          <Typography
            variant="h5"
            sx={{ fontSize: 16, textAlign: "center" }}
            gutterBottom
          >
            <h3>Trygve Storrønningen</h3>{" "}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: 14, textAlign: "center", padding: 2 }}
          >
            <TranslatedText defaultText=" Ранок 24 лютого став шоком , коли всі дізналися, що росіяни вторглися до України. Рідні Trygve Storrøningen проживають в Україні та перші три тижні війни перебували в оточенні, намагаючись вибратися звідти, щоб врятувати своє життя.  Коли вони, ризикуючи, змогли вийти з кільця, Трігве вирушив їм назустріч до кордону України і Словаччини, щоб забрати їх до свого дому в Норвегії." />

            <br></br>

            <TranslatedText
              defaultText="Trygve, як і раніше, має велике бажання допомагати українським біженцям. 
              І їм ще потрібна допомога. 
                На сьогоднішній день потреба в інформаційній підтримці залишається актуальною, 
                тому рік тому виникла і була реалізована ідея створити Українську 
                асоціацію Вестфолд і Телемарк, а згодом і сайт організації. 
                Через рік компанія Atticum Nettløsning почала створювати веб-сайт, 
                щоб допомогти біженцям з України швидше пройти період адаптації та інтеграції в новому суспільстві.
                "
            />
          </Typography>
        </Grid>
        <Grid item className="about-item" xs={6}>
          <div class="about-img2">
            <img src={Oksana} alt="" style={{ width: "100%", height: "30%" }} />
          </div>
        </Grid>
        <Grid item className="item-text" xs={6}>
          <div>
            <Typography
              variant="h5"
              sx={{ fontSize: 16, textAlign: "center" }}
              gutterBottom
            >
              <h3>
                <TranslatedText defaultText="Оксана Радулевич" />
              </h3>{" "}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: 14, textAlign: "center" }}
            >
              <TranslatedText
                defaultText=" Для всіх українців життя було поділено на «до» і «після» того жахливого ранку 24 лютого 2022 року. Росія розпочала повномасштабне вторгнення в Україну.
                Рятуючи життя, Оксана разом з маленьким сином залишили рідний Чернігів з першими вибухами в місті. Тоді почалася її дорога в нікуди. 
               Серце стискалося від жахливих новин з дому, де залишились рідні та близькі. Місто було оточене з перших днів війни, а жителі Чернігова ховалися в холодних підвалах. Росіяни бомбили житлові райони міста, було багато жертв. "
              />
              <br></br>
              <TranslatedText
                defaultText="Кінцева зупинка вимушеної подорожі для Оксани та її сина була в Норвегії, де їх гостинно прийняли в свій дім друзі. 
                До того, як нове життя почало налагоджуватись, деякий час все було як в тумані. Лише за допомоги небайдужих вирішувались формальні питання. 
                Сьогодні Оксана є виконавчим директором у Vestfold og Telemark Ukrainske Forening та має бажання і натхнення допомагати іншим. 
                В колаборації з групою «Українці в Ларвіку» та її адміністратором Валентиною Сердюк поступово створюється база корисної інформації для біженців з України на нашому сайті.  "
              />
            </Typography>
          </div>
        </Grid>
      </Grid>

      <Typography
        variant="body1"
        sx={{
          fontSize: 22,
          fontWeight: "200",
          textAlign: "left",
          marginTop: "15vh",
          "@media screen and (max-width: 600px)": {
            fontSize: "20px",
            marginTop: "5vh",
          },
        }}
      >
        <TranslatedText defaultText="Намагаєтеся з нами зв’язатися?" />
      </Typography>
      <div>
        <div className="contact-link">
          <a
            className="contact-a"
            href="/contact"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {
              <h2
                className="box-link"
                style={{
                  fontSize: "20px",
                  fontWeight: "400",
                  "@media screen and (max-width: 690px)": { fontSize: "18px" },
                }}
              >
                <TranslatedText defaultText="Перейдіть на сторінку контактів" />

                <ArrowForwardIcon />
              </h2>
            }
          </a>
        </div>
      </div>
    </Box>
  );
};

export default OmOss;
